import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Input, Button, Table, Alert } from 'antd'

import ConfirmButton from '@components/ConfirmButton'

import * as style from './style.scss'

@inject((store: any) => {
    const { popupStore, policiesStore } = store
    return { popupStore, policiesStore }
})
@observer
export default class PolicyParentsPopup extends Component<any, any> {
    state: any = {
        errors: {}
    }

    closePopup = () => {
        this.setState({ errors: {} })
        this.props.popupStore.togglePopup(false)
    }

    render() {
        const { popupType, info } = this.props.popupStore
        const { childrenList, parentsList, filteredList, filterText, filterList } = this.props.policiesStore
        const { errors } = this.state

        const footerButtons = (
            <div style={{ display: 'inline-block', width: '100%' }}>
                <div style={{ float: 'left', display: 'inline-block' }}>
                    <Button onClick={this.closePopup}>ביטול</Button>
                </div>
            </div>
        )

        const columns = [
            {
                title: 'מזהה',
                key: 'id',
                align: 'right',
                render: (_, record) => record.id
            },
            {
                title: 'שם הפוליסה',
                key: 'name',
                align: 'right',
                render: (_, record) => record.name
            }
        ]

        return (
            <Modal
                title={childrenList.length > 0 ? 'נמצאו פוליסות משוייכות' : 'רשימת פוליסות לשיוך'}
                visible={popupType === 'policyParents'}
                footer={footerButtons}
                onCancel={this.closePopup}
            >
                <div>
                    <strong>
                        {childrenList.length > 0
                            ? `תחת פוליסה זו נמצאו ${childrenList.length} פוליסות`
                            : 'בחר את הפוליסה אותה תרצה לשייך'}
                    </strong>
                </div>
                {childrenList.length > 0 ? (
                    <Alert type="warning" message="לא ניתן לשייך פוליסה זו לפוליסה אחרת כל עוד היא פוליסת הורה" />
                ) : (
                    ''
                )}
                <Input.Search
                    value={filterText}
                    placeholder="סינון פוליסה על פי שם או מזהה"
                    onChange={e => filterList(e.target.value)}
                />
                <Table
                    columns={columns}
                    dataSource={filteredList}
                    pagination={{
                        pageSize: 6
                    }}
                    rowKey="id"
                    style={{ padding: '0.2rem' }}
                    rowClassName={() => style.policy_row}
                    onRow={record => ({
                        onClick: () => {
                            if (childrenList.length > 0) {
                                window.open(`/insurance/${record['company_id']}/${record['id']}`)
                            } else {
                                this.props.addParentPolicy(record['id'])
                                this.closePopup()
                            }
                        }
                    })}
                />
            </Modal>
        )
    }
}
